// ------------------------------------------------------------------
// Tribzz links used across the marketing site.
//
// Every "Start your Tribzz" button opens TRIBZZ_URL in a new tab.
// If it's ever left empty, those buttons fall back to the Contact page
// with "Tribzz for my business" picked.
// ------------------------------------------------------------------
export const TRIBZZ_URL = "https://tribzz.com";

/** Where a "start your Tribzz" button should go. */
export function tribzzStartLink() {
  return TRIBZZ_URL ? { href: TRIBZZ_URL } : { to: { path: "/contact", query: { topic: "tribzz" } } };
}